import { RESTError } from "../core/RESTError";

/**
 * An error that occurs while adding a system that already exists.
 */
export class SystemDuplicateError extends RESTError {}
